export enum WEEE_STATUS {
  Accept = 'accept',
  Reject ='reject',
  ErrorNotFound = 'weee_link_not_found',
  ErrorExpired = 'weee_link_expired'
}

export const EXPIRED_STATUS_CODE =  400;
export const NOT_FOUND_STATUS_CODE = 404;
